import { put, call, takeLatest } from 'redux-saga/effects'
import {

  dStoresEditItemSagaAC,
  dStoresSetDataAC,
  dStoresSetDataSagaAC, dStoresSetPaginationAC
} from './dStoresActionCreators'
import { dashboardLoaderAC } from '../system/systemActionCreators'
import { getStoreList, changeStoresItem, getRestCashForAllPos } from './dStoresAPI'
import { IdStoresStateDataItem, typeStoreFilters } from './dStoresReducer'
import { errorGenerator, notificationCreator } from 'model/system/utils';
import * as process from "process";
import { paginationMapper, typePagination, typeRequestPagination } from "../system/constants";


type typeGetStoreResponse = Omit<IdStoresStateDataItem, 'checked' | 'cash_balance'>[]
export type typeGetEncashResponse = {
    'id': string,
    'storeId': string,
    'sum': number,
    'terminalSn': string,
    'updateDate': string,
    'userId': string,
}[]

// Temp data list mapper
const tempDataMapper = (tempResponseData: typeGetStoreResponse, responseEncashData: typeGetEncashResponse): IdStoresStateDataItem[] => {
  return tempResponseData.map((item) => {
    let cashBalance = null
    const terminals: typeGetEncashResponse = []
    if (responseEncashData && responseEncashData.length > 0) {
      cashBalance = responseEncashData.reduce((acc, terminal) => {
        if (terminal?.storeId === item.id) {
          terminals.push(terminal)
          acc = acc + terminal.sum
        }
        return acc
      }, 0)
    }

    return (
      {
        checked: false,
        id: item.id,
        name: item.name,
        address: item.address,
        phoneNumber: item.phoneNumber,
        email: item.email,
        manager: item.manager,
        managerPhoneNumber: item.managerPhoneNumber,
        industry: item.industry,
        description: item.description,
        deleted: item.deleted,
        cash_balance: cashBalance,
        terminals: terminals
      }
    )
  })
}

// Get data function-generator
function* getData(payload: {
  filters: typeStoreFilters,
  full?: boolean,
  paginationRequest: typeRequestPagination
}) {
  let response = yield call(getStoreList, payload);

  let responseEncash = process.env.REACT_APP_ENCASHMENT ? yield call(getRestCashForAllPos) : null;

  if (response.status === 200) {
    if (responseEncash && responseEncash.status === 200) {
      if (Array.isArray(response.data)) {
        const tempData: IdStoresStateDataItem[] = tempDataMapper(response.data, responseEncash.data);

        yield put(dStoresSetDataAC(tempData));
      } else {
        const pagination: typePagination = paginationMapper(response.data);
        const tempData: IdStoresStateDataItem[] = tempDataMapper(response.data.content, responseEncash.data);

        yield put(dStoresSetDataAC(tempData));
        yield put(dStoresSetPaginationAC(pagination));
      }
    } else {
      if (Array.isArray(response.data)) {
        const tempData: IdStoresStateDataItem[] = tempDataMapper(response.data, []);

        yield put(dStoresSetDataAC(tempData));
      } else {
        const pagination: typePagination = paginationMapper(response.data);
        const tempData: IdStoresStateDataItem[] = tempDataMapper(response.data.content, []);

        yield put(dStoresSetDataAC(tempData));
        yield put(dStoresSetPaginationAC(pagination));
      }

      if (responseEncash !== null) yield errorGenerator(response)
    }
  } else {
    yield errorGenerator(response)
  }
}

// ---------------------------------------------------------------------------------------------------------------------
// Saga set data
export function* dStoresSetDataWorker(
  actionObject: {
    type: string,
    payload: {
      filters: typeStoreFilters
      paginationRequest: typeRequestPagination
    }
  }
) {

  yield put(dashboardLoaderAC(true))

  yield getData(actionObject.payload)

  yield put(dashboardLoaderAC(false))

}

export function* dStoresSetDataWatcher() {
    yield takeLatest(dStoresSetDataSagaAC.type, dStoresSetDataWorker)
}


// ---------------------------------------------------------------------------------------------------------------------
// Saga edit data item
export function* dStoresEditDataItemWorker(
    actionObject: {
        type: string,
        payload: {
            detailItemObject: IdStoresStateDataItem,
            filters: typeStoreFilters
        }
    }
) {

    yield put(dashboardLoaderAC(true))

    let response = yield call(changeStoresItem, { dataObject: actionObject.payload.detailItemObject })

    if (response.status === 200) {
        yield notificationCreator('SUCCESS_CHANGE_ITEM')

        yield getData({ filters: actionObject.payload.filters } as any)

    } else {
        yield errorGenerator(response)
    }

    yield put(dashboardLoaderAC(false))

}

export function* dStoresEditDataWatcher() {
    yield takeLatest(dStoresEditItemSagaAC.type, dStoresEditDataItemWorker)
}
